import type {
  CreateReferralSourceBody,
  CreateReferralSourceResponse,
  EditReferralSourceBody,
  EditReferralSourceResponse,
  GetReferralMetricsResponse,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class ReferralService extends BaseService {
  getReferralMetrics(): Promise<GetReferralMetricsResponse> {
    return this.client.send('/api/referrals/metrics', {
      method: 'GET',
    });
  }

  createReferralSource(
    body: CreateReferralSourceBody,
  ): Promise<CreateReferralSourceResponse> {
    return this.client.send('/api/referrals/sources', {
      method: 'POST',
      body,
    });
  }

  editReferralSource(
    id: number,
    body: EditReferralSourceBody,
  ): Promise<EditReferralSourceResponse> {
    return this.client.send(`/api/referrals/sources/${id}`, {
      method: 'PUT',
      body,
    });
  }

  deleteReferralSource(id: number): Promise<void> {
    return this.client.send(`/api/referrals/sources/${id}`, {
      method: 'DELETE',
    });
  }

  exportReferralMetrics() {
    return this.client.send('/api/referrals/export', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
